import keyMirror from 'keymirror';

export const bookDetailsActionTypes = keyMirror({
	GET_BOOK_DETAILS_REQUEST: null,
	GET_BOOK_DETAILS_SUCCESS: null,
	GET_BOOK_DETAILS_ERROR: null,
	ADD_TO_MY_BOOKS_REQUEST: null,
	ADD_TO_MY_BOOKS_SUCCESS: null,
	ADD_TO_MY_BOOKS_ERROR: null,
	REMOVE_FROM_MY_BOOKS_REQUEST: null,
	REMOVE_FROM_MY_BOOKS_SUCCESS: null,
	REMOVE_FROM_MY_BOOKS_ERROR: null,

	CLEAR_BOOKS_DETAILS: null,
});

export const getBookHeaderColumns = (t) => [
	t('book_details.header.columns.subject'),
	t('book_details.header.columns.title'),
	t('book_details.header.columns.paragraph'),
	t('book_details.header.columns.number'),
];
